export const PUBLIC_PREFIX = '/api';


export const CMS_END_POINT = {
  getBounties: `${PUBLIC_PREFIX}/bounties?populate=cover,rewards,thumbnail,rewards.reward,rewards.reward.image`,
  getBanner: `${PUBLIC_PREFIX}/banners?populate=cover`,
};
